import { render, staticRenderFns } from "./reviewInfo.vue?vue&type=template&id=6b739496&scoped=true&"
import script from "./reviewInfo.vue?vue&type=script&lang=js&"
export * from "./reviewInfo.vue?vue&type=script&lang=js&"
import style0 from "./reviewInfo.vue?vue&type=style&index=0&id=6b739496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b739496",
  null
  
)

export default component.exports